import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import { isApiResponse } from '../helpers/utils.js';
import TicketDetailTable from './TicketDetailTable.jsx';
import './TicketReport.css';

class QCAgentPerTeamTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedTeam: null,
      selectedColumnType: null,
      selectedAgentName: null
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_qc_agent_performance_team();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.chainID !== this.props.chainID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.issue_type !== this.props.issue_type ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team ||
      prevProps.team_member !== this.props.team_member
    ) {
      this.get_filtered_qc_agent_performance_team();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#ChannelTable')) {
      $('#ChannelTable').DataTable().clear().destroy();
    }
  }

  get_filtered_qc_agent_performance_team() {
    var that = this;
    if (this.props.shouldLoadData) {
      const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        team_member: this.props.team_member || [],
        group_by: 'team',
        report_code: 'qc_agent_performance_team_wise',
        download: 0
      };

      isApiResponse(false);

      if ($.fn.DataTable.isDataTable('#ChannelTable')) {
        $('#ChannelTable').DataTable().clear().destroy();
      }

      $('#ChannelTable').DataTable({
        order: [],
        processing: true,
        serverSide: true,
        bDestroy: true,
        paging: true,
        pageLength: 5,
        bInfo: false,
        sPaginationType: 'simple_numbers',
        autoWidth: true,
        responsive: false,
        scrollX: true,
        searching: true,
        lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
        fixedColumns: { leftColumns: 1 },
        ajax: {
          url: config.get('API_URL') + '/ServiceReport/qc_agent_performance',
          type: 'POST',
          data: postData,
          dataSrc: function (json) {
            isApiResponse(true);
            that.setState({ isChange: false });
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader('Authorization', localStorage.usertoken);
          },
          error: function (data) {
            isApiResponse(true);
            alert('Failed to load data. Please try again');
            console.log('error', data);
          },
          complete: function (data) {
            isApiResponse(true);
          }
        },
        columns: [
          { data: 'Team Name', width: '180px' },
          { data: 'Agent Name', width: '150px' },
          { data: 'Within TAT - No Of Tickets Allocated', width: '100px' },
          { data: 'Within TAT - No Of Tickets QC Closed', width: '100px' },
          { data: 'Outside TAT - No Of Tickets Allocated', width: '100px' },
          { data: 'Outside TAT - No Of Tickets QC Closed', width: '100px' },
          { data: 'No of Tickets Re-opened by Agent', width: '120px' },
          { data: '% of Tickets Re-opened by Agent', width: '120px' },
          { data: '% of Tickets Closed Within TAT', width: '120px' },
          { data: 'Tickets created by subs closed by agent in last 48 hour', width: '200px' },
          { data: '% Repeat Tickets', width: '100px' },
          { data: 'Tickets closed by this agent reopend by Customer(E-Mail)', width: '180px' },
          { data: '% of Tickets Reopen by Customer(E-Mail)', width: '150px' },
          { data: 'Actual Work Hours Spent', width: '120px' },
          { data: 'Productivity', width: '100px' },
          { data: 'Cost/Ticket', width: '100px' }
        ],
        columnDefs: [
          {
            targets: 0,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-150'>${val}</div>`;
            }
          },
          {
            targets: [1],
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-80'>${val}</div>`;
            }
          },
          {
            targets: [2, 3, 4, 5, 6, 9, 11],
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          },
          {
            targets: [7, 8, 10, 12],
            render: function (data) {
              return data == null ? '0%' : data + '%';
            }
          }
        ]
      });
    }
  }

  handleCellClick(rowData, colIndex) {
    const teamName = rowData['Team Name'];
    const agentName = rowData['Agent Name'];
    const columnMapping = {
      2: 'within_tat_allocated',
      3: 'within_tat_qc_closed',
      4: 'outside_tat_allocated',
      5: 'outside_tat_qc_closed',
      6: 'reopened_by_agent',
      9: 'repeat_48hr',
      11: 'email_reopened'
    };
    const colType = columnMapping[colIndex];
    if (colType) {
      this.setState({
        showDetails: true,
        selectedTeam: teamName,
        selectedAgentName: agentName,
        selectedColumnType: colType
      });
    }
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedTeam: null,
      selectedColumnType: null,
      selectedAgentName: null
    });
  }

  render() {
    const { showDetails, selectedTeam, selectedColumnType } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
          <table id="ChannelTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th rowSpan="2" className="merchant-header-default">Team Name</th>
                <th rowSpan="2" className="merchant-header-default">Agent Name</th>
                <th colSpan="2" className="merchant-header-default">Within TAT</th>
                <th colSpan="2" className="merchant-header-default">Outside TAT</th>
                <th colSpan="10" className="merchant-header-default">Performance</th>
              </tr>
              <tr>
                <th className="merchant-header-default">No. Of Tickets Allocated</th>
                <th className="merchant-header-default">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default">No. Of Tickets Allocated</th>
                <th className="merchant-header-default">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default">No. of Tickets Re-opened by Agent</th>
                <th className="merchant-header-default">% of Tickets Re-opened by Agent</th>
                <th className="merchant-header-default">% of Tickets Closed Within TAT</th>
                <th className="merchant-header-default">New tickets created by subscription closed by this agent in last 48 hour</th>
                <th className="merchant-header-default">% Repeat Tickets</th>
                <th className="merchant-header-default">Tickets closed by this agent reopend by Customer(E-Mail)</th>
                <th className="merchant-header-default">% of Tickets Reopen by Customer(E-Mail)</th>
                <th className="merchant-header-default">Actual Work Hours Spent</th>
                <th className="merchant-header-default">Productivity</th>
                <th className="merchant-header-default">Cost/Ticket</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>

        {showDetails && (
          <TicketDetailTable
            key={`${selectedTeam}-${selectedColumnType}`}
            tableId="qcTeamDetailsTable"
            apiUrl="/ServiceReport/qc_agent_performance_details"
            postData={{
              start_date: this.props.yestSend,
              end_date: this.props.todSend,
              download: 0,
              report_code: 'qc_agent_performance_team_wise',
              group_by: 'team',
              group_value: selectedTeam,
              agent_name: this.state.selectedAgentName,
              column_type: selectedColumnType,
              merchant: this.props.merchantID || [],
              store: this.props.storeID || [],
              issue_category: this.props.cf_issue_sub_category || [],
              city: this.props.city || [],
              channel: this.props.channel || [],
              product: this.props.product || [],
              team: this.props.team || [],
              team_member: this.props.team_member || []
            }}
            title={`Ticket Details - ${selectedTeam}`}
            columnType={selectedColumnType}
            objectType={this.props.object_type}
            onClose={() => this.closeDetails()}
            downloadConfig={{
              fn: 'qc_agent_performance_team_wise_details.csv.gz',
              url: '/service_reports/qc_agent_performance_details',
              filters: {
                start_date: this.props.yestSend,
                end_date: this.props.todSend,
                download: 1,
                report_code: 'qc_agent_performance_team_wise_details',
                group_by: 'team',
                group_value: selectedTeam,
                agent_name: this.state.selectedAgentName,
                column_type: selectedColumnType,
                merchant: this.props.merchantID,
                store: this.props.storeID,
                issue_category: this.props.cf_issue_sub_category,
                city: this.props.city,
                channel: this.props.channel,
                product: this.props.product,
                team: this.props.team,
                team_member: this.props.team_member
              },
              timeout: 180
            }}
          />
        )}
      </div>
    );
  }
}

export default QCAgentPerTeamTab;
